<template>
    <div class="comment-wrapper">
        <label :for="name">{{resource('SprintPlanning_Comments_Add_DisplayName')}}</label>
        <textarea ref="comment" :name="name" class="new-comment form-control" v-model="value" @blur="emitValue()"/>
    </div>
</template>

<script>

import guidMixin from '../../../Util/Mixins/guid';
import resourceMixin from '../../../Util/Mixins/resources';

export default {
    name: 'sprint-planning-comment',
    mixins: [guidMixin,resourceMixin],
    methods: {
        emitValue(value) {
            this.$emit('input', this.$refs.comment.value);
        },
        getValue() {
            return this.value;
        },
        setValue(value) {
            this.value = value;
        }
    },
    data() {
        return {
            value: '',
            name: `comment-${this.guid()}`
        };
    }
};
</script>

<style lang="scss" scoped src="../Style/comment.scss">

</style>